const siteData = {
  siteName: "QBits9",
  siteUrl: "https://qbits9.com",
  brandName: "QBits9",
  tagline: "AI automation and digital solutions company",
  description:
    "QBits9 is an AI automation and custom software development company based in Surat, Gujarat, India. We build practical AI automations, custom web and mobile apps, SaaS platforms, ERP integrations, and desktop software for businesses worldwide.",
  defaultShareImage: "/favicon-512x512.png",
  phoneDisplay: "+91 7779027200",
  phoneHref: "+917779027200",
  // email: "hello@qbits9.com",
  address: {
    streetAddress: "261, Silverstone Arcade",
    addressLocality: "Surat",
    addressRegion: "Gujarat",
    postalCode: "395004",
    addressCountry: "IN",
  },
  addressDisplay: "261, Silverstone Arcade, Surat, Gujarat 395004, India",
  openingHours: "Mo-Sa 10:00-19:00",
  geoRegion: "IN-GJ",
  geoPlacename: "Surat, Gujarat, India",
  geoPosition: "21.1702;72.8311",
  geoICBM: "21.1702, 72.8311",
  sameAs: [
    "https://www.linkedin.com/company/qbits9",
    "https://twitter.com/qbits9",
    "https://www.instagram.com/qbits9/",
  ],
  socialHandle: "@qbits9",

  // ─── GEO: Entity Authority Fields ───
  foundingDate: "2022",
  foundingLocation: "Surat, Gujarat, India",
  numberOfEmployees: { min: 10, max: 50 },
  priceRange: "$$",
  currenciesAccepted: "INR, USD",
  paymentAccepted: "Bank Transfer, UPI, Credit Card",

  // GEO: knowsAbout — tells AI engines what topics QBits9 is an authority on
  knowsAbout: [
    "Artificial Intelligence",
    "Machine Learning",
    "Workflow Automation",
    "AI Automation",
    "AI Automation for Small Business",
    "Business Process Automation",
    "Web Development",
    "Mobile App Development",
    "React Development",
    "Next.js Development",
    "Node.js Development",
    "Python Development",
    "SaaS Development",
    "ERP Development",
    "Custom Software Development",
    "Desktop Software Development",
    "Hospital Management Software",
    "Digital Transformation",
    "API Development",
    "Cloud Computing",
    "UI/UX Design",
  ],

  // GEO: Service keywords for AI entity matching
  serviceKeywords: {
    aiAutomation: [
      "AI automation", "AI automation for small business", "workflow automation",
      "business automation", "intelligent automation", "process automation",
      "AI chatbot", "automated reporting", "lead automation",
    ],
    webMobile: [
      "web development", "mobile app development", "React development",
      "progressive web app", "custom web application", "iOS app development",
      "Android app development", "API development",
    ],
    saasErp: [
      "SaaS development", "ERP development", "custom CRM", "cloud platform",
      "enterprise software", "business management software",
      "inventory management system", "billing software",
    ],
    desktopSoftware: [
      "desktop software development", "Electron app", "cross-platform application",
      "offline business software", "POS system", "internal business tools",
    ],
  },

  // GEO: areaServed for international AI visibility
  areaServed: [
    "India", "United States", "United Kingdom",
    "United Arab Emirates", "Australia", "Canada",
    "Singapore", "Germany", "Netherlands",
  ],

  // Sitemap routes
  routes: [
    { path: "/hospital-management-software", lastmod: "2026-09-29", changefreq: "weekly", priority: 0.8 },
    { path: "/", lastmod: "2026-09-29", changefreq: "weekly", priority: 1.0 },
    { path: "/services/ai-automation", lastmod: "2026-09-29", changefreq: "monthly", priority: 0.9 },
    { path: "/services/web-mobile-development", lastmod: "2026-09-29", changefreq: "monthly", priority: 0.9 },
    { path: "/services/saas-erp-development", lastmod: "2026-09-29", changefreq: "monthly", priority: 0.9 },
    { path: "/services/desktop-software", lastmod: "2026-09-29", changefreq: "monthly", priority: 0.9 },
    { path: "/lumina", lastmod: "2026-09-29", changefreq: "weekly", priority: 0.9 },
    { path: "/blog", lastmod: "2026-09-29", changefreq: "weekly", priority: 0.8 },
    { path: "/contact", lastmod: "2026-09-29", changefreq: "monthly", priority: 0.8 },
    { path: "/privacy-policy", lastmod: "2026-09-29", changefreq: "yearly", priority: 0.3 },
    { path: "/terms-of-service", lastmod: "2026-09-29", changefreq: "yearly", priority: 0.3 },
  ],
};

module.exports = siteData;
module.exports.default = siteData;
